import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, " Browseren understøtter ikke IFRAME SRCDOC funktionaliteten. Prøv at benytte en nyere version af browseren ellen en anden browser. "))
}